import { LOGRAR_SEGUROS_API_URL, LOGRAR_SEGUROS_X_USER } from "../utils/constantes";

export default class LograrSegurosService {

    static _buildHeaders() {
        const headers = new Headers();
        headers.append("x-user", LOGRAR_SEGUROS_X_USER);
        return headers;
    }

    /**
     * Busca individuos por tipo+número de documento o por apellido.
     * @param {Object} params - { tipoDoc, nroDoc } para modo 1, o { apellido } para modo 2
     * @returns {Object} Respuesta de la API: { success, total, data }
     */
    static async buscarIndividuo({ tipoDoc, nroDoc, apellido } = {}) {
        const queryParams = new URLSearchParams();

        if (apellido) {
            queryParams.append("apellido", apellido);
        } else {
            queryParams.append("tipoDoc", tipoDoc);
            queryParams.append("nroDoc", nroDoc);
        }

        const response = await fetch(
            `${LOGRAR_SEGUROS_API_URL}/buscar-individuo?${queryParams.toString()}`,
            { method: "GET", headers: this._buildHeaders() }
        );

        if (!response.ok) {
            throw new Error(`Error al buscar individuo: HTTP ${response.status}`);
        }

        return await response.json();
    }

    /**
     * Consulta el estado de cobertura de un asegurado.
     * @param {string} tipoDoc - Tipo de documento (DNI, CUIT)
     * @param {string} nroDoc - Número de documento
     * @returns {Object} Respuesta de la API con estadoCobertura y habilitadoParaPrestacion
     */
    static async consultarCobertura(tipoDoc, nroDoc) {
        const queryParams = new URLSearchParams({ tipoDoc, nroDoc });

        const response = await fetch(
            `${LOGRAR_SEGUROS_API_URL}/consultar-asegurado?${queryParams.toString()}`,
            { method: "GET", headers: this._buildHeaders() }
        );

        if (!response.ok) {
            throw new Error(`Error al consultar cobertura: HTTP ${response.status}`);
        }

        return await response.json();
    }
}
